import { gql } from '@lcs/shared/api';

export const deletePromptMutation = gql`
   mutation DeletePrompt($promptId: UInt!) {
      deletePrompt(id: $promptId)
   }
`;
